<template>
  <base-dblclick-input
    modelType="contact"
    :model-id="clientContact.id"
    field-name="prefix"
    :field-value="clientContact.prefix"
    inputType="text"
    @refetch="fetchNewClients"
  ></base-dblclick-input>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

  const props = defineProps({
      clientContact: Object
  })

  const emit = defineEmits(['refetch-clients'])

  function fetchNewClients () {
      emit('refetch-clients')
  }
</script>